import { DITypes } from "@/core/@types/types";
import type { IToastNotification } from "@/composables/shared/notification/types";
import { IDefaultContabilResponse } from "@/services/contabil/types";
import { IHttpResponse } from "@/core/services/protocols/types";
import { inject, injectable } from "inversify";
import "reflect-metadata";

@injectable()
export abstract class ContabilGatewayError {
  constructor(
    @inject(DITypes.NOTIFICATION)
    readonly notification: IToastNotification<string>
  ) {}

  readonly DEFAULT_ERROR = "Ocorreu um erro inesperado";

  hasError<T>(response: IHttpResponse<IDefaultContabilResponse<T>>) {
    return response.statusCode !== 200 || response.body?.code !== 200;
  }

  handleErrors<T>(response: IHttpResponse<IDefaultContabilResponse<T>>): void {
    const errors = response.body?.errors;
    const hasErrorList = (errors?.length || 0) > 0;

    if (!hasErrorList) {
      this.notification.showNotification(this.DEFAULT_ERROR, {
        type: "error",
        timeout: 3000
      });

      return;
    }

    return errors?.forEach((error) =>
      this.notification.showNotification(error.message, {
        type: "error",
        timeout: 3000
      })
    );
  }
}
